var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrdner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Ordner__Icn/40px/Ordner",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Ordner__Color/20px/Platzhalter-Transparent",
    fillRule: "nonzero",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Icn_40px_Ordner__Rectangle",
    d: "M0 0H40V40H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.8133486,17.5516043 C30.1623539,17.1056101 30.7686001,16.9517199 31.28807,17.1772496 C31.8075581,17.4027873 32.1090723,17.9508146 32.0216237,18.5094961 L31.239,23.534 L35.3493739,26.7622389 C35.7597541,27.0850601 35.9213985,27.625937 35.766322,28.1151879 L35.7209152,28.236269 C35.4952265,28.7549223 34.9480394,29.0560161 34.3890268,28.9690969 L29.283,28.175 L26.0048799,32.3481811 C25.6825148,32.7591521 25.1415874,32.9214561 24.6520435,32.7667471 L24.5308842,32.7214259 C24.0118351,32.496064 23.7103232,31.9487431 23.7972162,31.3895545 L24.613,26.143 L20.5508097,22.9522382 C20.1394912,22.6299837 19.9770287,22.0888158 20.1319347,21.5991345 L20.1773127,21.4779433 C20.4029377,20.9588039 20.9507406,20.6575944 21.5090408,20.745016 L26.672,21.547 Z M29.995,20.152 L27.8652222,22.8621607 C27.5881929,23.2154163 27.1409666,23.391791 26.6966127,23.3226143 L23.154,22.772 L25.9271152,24.9511029 C26.2411464,25.1981627 26.415025,25.5787068 26.4012949,25.9721718 L26.3872594,26.1200914 L25.823,29.745 L28.0903371,26.8601081 C28.3373996,26.5459525 28.7180447,26.3720154 29.1116306,26.3857899 L29.2595963,26.399847 L32.743,26.941 L29.9255834,24.7271532 C29.61151,24.4800905 29.4376126,24.0995101 29.4513649,23.7059924 L29.4654108,23.5580523 L29.995,20.152 Z M13.263932,8 C14.0214761,8 14.7140024,8.42800475 15.0527864,9.10557281 L16.5,11 L30,11 C31.1045695,11 32,11.8954305 32,13 L32,15 L30,15 L30,13 L15.263932,13 L13.263932,10 L8,10 L8,27 L21.128,27 L20.765,29 L8,29 C6.8954305,29 6,28.1045695 6,27 L6,10 C6,8.8954305 6.8954305,8 8,8 L13.263932,8 Z",
    id: ".._.._src_svg_Icn_40px_Ordner__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdner);
export default __webpack_public_path__ + "static/media/Ordner.3bbcde41cdf792ae5060737f2448b9b5.svg";
export { ForwardRef as ReactComponent };